<template>
  <el-aside width="200px">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      style="height: calc(100vh - 60px);"
      router
    >
      <el-menu-item index="/statistics">
        <el-icon><DataAnalysis /></el-icon>
        <template #title>工作台</template>
      </el-menu-item>
      <!-- <el-menu-item index="/setting">
        <el-icon><Setting /></el-icon>
        <template #title>网站设置</template>
      </el-menu-item> -->
      <el-menu-item index="/banners">
        <el-icon><Picture /></el-icon>
        <template #title>banner图设置</template>
      </el-menu-item>
      <el-menu-item index="/users">
        <el-icon><User /></el-icon>
        <template #title>管理员管理</template>
      </el-menu-item>
      <el-menu-item index="/members">
        <el-icon><UserFilled /></el-icon>
        <template #title>用户管理</template>
      </el-menu-item>
      <el-sub-menu index="/cards">
        <template #title>
          <el-icon><Postcard /></el-icon>
          <span>名片管理</span>
        </template>
        <el-menu-item index="/cards">名片管理</el-menu-item>
        <el-menu-item index="/cards/templet">名片样式</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="/company">
        <template #title>
          <el-icon><OfficeBuilding /></el-icon>
          <span>公司管理</span>
        </template>
        <el-menu-item index="/company">公司列表</el-menu-item>
        <el-menu-item index="/companycates">公司分类</el-menu-item>
      </el-sub-menu>
      <el-sub-menu index="/goods">
        <template #title>
          <el-icon><Goods /></el-icon>
          <span>产品管理</span>
        </template>
        <el-menu-item index="/goods">产品列表</el-menu-item>
        <el-menu-item index="/cates">产品分类</el-menu-item>
      </el-sub-menu>
      <el-menu-item index="/setmeal">
        <el-icon><Present /></el-icon>
        <template #title>套餐管理</template>
      </el-menu-item>
      <el-menu-item index="/orders">
        <el-icon><Document /></el-icon>
        <template #title>订单管理</template>
      </el-menu-item>
      <el-menu-item index="/qa">
        <el-icon><ChatLineSquare /></el-icon>
        <template #title>问题答疑</template>
      </el-menu-item>
      <el-menu-item index="/bidding">
        <el-icon><Histogram /></el-icon>
        <template #title>竞投广告</template>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import {useRoute} from 'vue-router'
const route = useRoute()
const path = route.path
const activeIndex = ref(path)

</script>
